<div class="help-dialog">
  <div class="help-dialog-header d-flex align-items-center justify-content-between">
    <div class="help-title">How to connect</div>
    <button type="button" class="btn btn-link p-0 text-decoration-none" (click)="close()" aria-label="Close">
      <span class="material-icons">close</span>
    </button>
  </div>

  <div class="help-dialog-body">
    <div class="mb-3">
      <div class="section-title">How to connect:</div>
      <div class="text-muted">
        This section includes all the settings required to connect both your RTK base and RTK rover to the GeoAstra NTRIP Caster mountpoint.
      </div>
    </div>

    <div class="mb-1">
      <div class="section-title">Tip:</div>
      <div class="text-muted">
        To pass correction data correctly between the base and the rover, make sure both are connected to the same mountpoint.
      </div>
    </div>
  </div>
</div>


